export const getIsBackToTopButtonShown = state => state.backToTop.isBackToTopButtonShown;
